import { apiClient } from './client';
import { User } from '../contexts/AuthContext';

export interface UpdateProfileData {
  first_name?: string;
  last_name?: string;
  phone?: string;
  level?: string;
  preferred_times?: string;
  about_me?: string;
  show_phone_in_match?: boolean;
}

export interface PublicUser {
  id: string;
  first_name: string;
  last_name: string;
  level?: string;
  elo: number;
  photo_url?: string;
  about_me?: string;
}

export interface PlayedEvents {
  leagues: Array<{ id: number; name: string; level?: string; league_type?: string }>;
  seasons: Array<{ id: number; name: string; season_class: string; season_type: string; end_date: string }>;
}

export const usersApi = {
  getMe: () => apiClient.get<User>('/api/users/me'),

  updateMe: (data: UpdateProfileData) => apiClient.put<User>('/api/users/me', data),

  getPublic: (id: string) => apiClient.get<PublicUser>(`/api/users/${id}`),

  getPlayedEvents: (id: string) => apiClient.get<PlayedEvents>(`/api/users/${id}/played-events`),

  uploadPhoto: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/api/users/me/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
